/** True when the node is (or is inside) a field where the user types. */
export function isEditableElement(target) {
  if (!(target instanceof HTMLElement)) return false;
  return Boolean(
    target.closest(
      "input, select, textarea, [contenteditable='true'], [role='listbox'], [role='combobox'], [data-prevent-section-spy='true']"
    )
  );
}

export function isTypingInForm() {
  return isEditableElement(document.activeElement);
}
